
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/developers/sponsor-a-search",
      function () {
        return require("private-next-pages/products/developers/sponsor-a-search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/developers/sponsor-a-search"])
      });
    }
  